import _ from 'lodash';
import {
  GET_DASHBOARD_CHART,
  GET_DASHBOARD_REP_SCORECARD,
  GET_DASHBOARD_STATS,
  GET_DASHBOARD_NEW_PHYSICIAN,
  SEARCH_PRODUCT,
  CLEAR_PRODUCT,
  GET_TOP_MEDICATION,
  GET_TOP_CITIES,
  GET_TOP_STATE,
  GET_TOP_SPECIALIZATIONS,
  GET_TOP_COPAY_NETWORKS,
  GET_TOP_PAYORS,
  GET_TOP_PHYSICIANS, GET_TOP_GROUPS,
  GET_DASHBOARD_GROWTH_BY_SPECIALIZATIONS,
  GET_TOP_HUBS, GET_SINGLE_REPORT,
  GET_DASHBOARD_SYNC_PAK_VS_SORT_PAK, GET_DASHBOARD_USER_WORKFLOW, GET_DASHBOARD_NOTE_COUNT, GET_UNASSIGNED_PHYSICIANS,
  GET_DASHBOARD_SCRIPT_WORKFLOW,
} from '../actions/dashboard';

const initialState = {
  dashboardStats: {},
  dashboardChart: [],
  dashboardGrowthBySpecializations: [],
  dashboardSyncPakVsSortPak: [],
  dashboardPageData: [],
  dashboardTotalPage: 1,
  dashboardProduct: [],
  dashboardProductTotalPage: 1,
  dashboardSingleReport: [],
  dashboardSingleReportTotalPAge: 1,
  statusRequest: '',
  dashboardWorkflowData: [],
  dashboardScriptWorkflowData: [],
  dashboardNoteCountData: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DASHBOARD_STATS.SUCCESS:
      return {
        ...state,
        dashboardStats: payload.data.response,

      };

    case GET_DASHBOARD_CHART.SUCCESS:
      return {
        ...state,
        dashboardChart: payload.data.scripts,

      };

    case GET_DASHBOARD_GROWTH_BY_SPECIALIZATIONS.REQUEST:
      return {
        ...state,
        statusRequest: 'request',
        dashboardGrowthBySpecializations: [],
      };

    case GET_DASHBOARD_GROWTH_BY_SPECIALIZATIONS.SUCCESS:
      return {
        ...state,
        statusRequest: 'success',
        dashboardGrowthBySpecializations: payload.data.data,

      };

    case GET_DASHBOARD_SYNC_PAK_VS_SORT_PAK.REQUEST:
      return {
        ...state,
        dashboardSyncPakVsSortPak: [],
      };
    case GET_DASHBOARD_SYNC_PAK_VS_SORT_PAK.SUCCESS:
      return {
        ...state,
        dashboardSyncPakVsSortPak: payload.data,
      };

    case GET_DASHBOARD_REP_SCORECARD.SUCCESS:
      return {
        ...state,
        dashboardPageData: payload.data.data,
        dashboardTotalPage: payload.data._meta.pageCount,
      };

    case GET_DASHBOARD_SCRIPT_WORKFLOW.SUCCESS:
      return {
        ...state,
        dashboardScriptWorkflowData: payload.statusCounts.map((s) => ({
          ...s,
          reasons: s.reasons.length ? s.reasons.join(', ') : '-',
        })),
      };

    case GET_DASHBOARD_USER_WORKFLOW.SUCCESS: {
      return {
        ...state,
        dashboardWorkflowData: payload.result,
      };
    }

    case GET_DASHBOARD_NOTE_COUNT.SUCCESS: {
      return {
        ...state,
        dashboardNoteCountData: payload.data,
      };
    }

    case GET_DASHBOARD_NEW_PHYSICIAN.SUCCESS:
      return {
        ...state,
        dashboardPageData: payload.data.data,
        dashboardTotalPage: payload.data._meta.pageCount,
      };

    case SEARCH_PRODUCT.SUCCESS: {
      return {
        ...state,
        dashboardProduct: payload.data.data.response,
      };
    }

    case CLEAR_PRODUCT: {
      return {
        ...state,
        dashboardProduct: [],
      };
    }

    case GET_TOP_MEDICATION.SUCCESS: {
      return {
        ...state,
        dashboardPageData: _.orderBy(payload.data.data, 'quantity', 'desc'),
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_CITIES.SUCCESS: {
      return {
        ...state,
        dashboardPageData: _.orderBy(payload.data.data, 'patients', 'desc'),
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_STATE.SUCCESS: {
      return {
        ...state,
        dashboardPageData: _.orderBy(payload.data.data, 'patients', 'desc'),
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_SPECIALIZATIONS.SUCCESS: {
      return {
        ...state,
        dashboardPageData: payload.data.data,
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_COPAY_NETWORKS.SUCCESS: {
      return {
        ...state,
        dashboardPageData: payload.data.data,
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_PAYORS.SUCCESS: {
      return {
        ...state,
        dashboardPageData: _.orderBy(payload.data.data, 'patients', 'desc'),
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_HUBS.SUCCESS: {
      return {
        ...state,
        dashboardPageData: payload.data.data,
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_PHYSICIANS.SUCCESS: {
      return {
        ...state,
        dashboardPageData: _.orderBy(payload.data.data, 'sales', 'desc'),
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_UNASSIGNED_PHYSICIANS.SUCCESS: {
      return {
        ...state,
        dashboardPageData: payload.data.data.map((d) => ({ ...d, id: d.physicianId })),
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_TOP_GROUPS.SUCCESS: {
      return {
        ...state,
        dashboardPageData: payload.data.data,
        dashboardTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_SINGLE_REPORT.REQUEST: {
      return {
        ...state,
        statusRequest: 'request',
      };
    }

    case GET_SINGLE_REPORT.SUCCESS: {
      return {
        ...state,
        statusRequest: 'success',
        dashboardSingleReport: payload.data,
        dashboardSingleReportTotalPAge: payload._meta.pageCount,
      };
    }

    case GET_SINGLE_REPORT.FAIL: {
      return {
        ...state,
        statusRequest: 'fail',
      };
    }

    default:
      return state;
  }
};

export default reducer;
